import React, { useEffect } from 'react';
import { IonButton, IonCol, IonGrid, IonPage, IonRow } from '@ionic/react';
import { PAGE_TITLES, REGISTER_TO_GET_FULL_ACCESS } from '../../../utils/constants';
import { EVENT, SCREEN } from '../../../utils/constants.analytics';
import { MyloadTiles } from '../../../web/components/myloads';
import { logEvent, setScreenName } from '../../../utils/Analytics';
import "./MyLoads.scss";
import { ToastMessage } from '../../../utils/ToastMessage';
import { isEntitled } from '../../../utils/common';

const MyLoadsPage:React.FC<any> = (props:any) => {
    const { Component, history } = props;
    const handleClick = (path: string) => {
        if(isEntitled('search', 'newSearch')){
            history && history.push(path);
        }else{
            ToastMessage.show(REGISTER_TO_GET_FULL_ACCESS);
        }
    }
    
    useEffect(() => {
        window.scrollTo(0,0);
        // Analytics implementation
        setScreenName("my_loads_menu_page");
        logEvent(EVENT.SV_VIEW_MYLOADS, {
        screen: SCREEN.MYLOADS,
        carrierId:(props?.userDetails?.memberDetailsResponse?.member?.carrierId) || ''});
    }, [])

    return (
        <IonPage className="desktop-page myloads-page">
            <IonGrid className="header">
                <IonRow>
                    <IonCol size="6">
                        <h1>
                            { PAGE_TITLES.MY_LOADS }
                        </h1>
                    </IonCol>
                    <IonCol size="6" className="right">
                        <IonButton className="find-new-btn" onClick={() => handleClick('/app/search')}>
                            Find New Freight
                        </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
            <MyloadTiles {...props} />
            <Component {...props} />
        </IonPage>
    );
};

export default MyLoadsPage; 